export const SERVER_URL = 'https://swar8080.win';
export const ROUTE_ROOT = '/Wutbot-Demo';



// WEBPACK FOOTER //
// ./src/config.js